import { useCallback } from 'react';
import { SelectedFile } from '../types';

type SelectableItem = {
  id: string;
  title: string;
  file: { id: number };
};

/**
 * Creates a handler for mapping selected item IDs to SelectedFile objects.
 * Commonly used with SuitabilitySelectableList's setSelectedItemIds prop.
 */
export function useItemSelectionMapping<T extends SelectableItem>(items: T[]) {
  return useCallback(
    (ids: string[]): SelectedFile[] => {
      return ids.map(id => {
        const item = items.find(i => i.id === id);
        return {
          id,
          name: item?.title ?? 'Untitled file',
          fileId: item?.file.id ?? -1,
        };
      });
    },
    [items],
  );
}
